<template>
<div>
  <v-container>
    <v-row>
      <v-col cols="12" class="text-center">
        <div v-if="btnVisible">
          <v-btn v-if="defaultEmergencyNumber !== null && defaultEmergencyNumber.number !== null " block dark color="red" class="h-50" :href="`tel:${defaultEmergencyNumber.number}`">
            <v-icon dark style="padding-right: 10px;">
              mdi-phone
            </v-icon> {{ defaultEmergencyNumber.display_name }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
  <v-container>
    <getting-data-overlay :is_loading="isLoadingOverview"
                          :loading_display_title="$vuetify.lang.t('$vuetify.emergency_numbers.getting_data_title')"></getting-data-overlay>
    <v-row v-if="!isLoadingOverview && !hasLoadingError">

      <v-col cols="12">
        <v-list transition="fade-transition">
          <template v-for="(eNumber, index) in emergencyNumbers">
              <v-list-item v-if="eNumber.number !== defaultEmergencyNumber.number" class="emergency-number-item" :key="'eNumber_'+index">
                <v-btn block dark color="primary" class="h-50" :href="`tel:${eNumber.number}`">
                  <v-icon dark style="padding-right: 10px;">
                    mdi-phone
                  </v-icon>
                  {{ eNumber.display_name}}
                </v-btn>
              </v-list-item>
              <v-divider v-if="index + 1 < emergencyNumbers.length"
                         :key="'divider_'+index">

              </v-divider>
          </template>
        </v-list>
      </v-col>
    </v-row>
    <v-row v-if="hasLoadingError">
      <v-col cols="12">
        <v-col cols="12" class="subtitle-1 text-center">
          {{ $vuetify.lang.t('$vuetify.errors.EmergencyNumbersOverviewNotLoaded') }}
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import appSettings from "@/mixins/config/appSettings";
import resourcesApi from "@/api/resources/resourcesApi";
import GettingDataOverlayComponent
  from "@/components/modules/global/gettingDataOverlayComponent/GettingDataOverlayComponent";

export default {
name: "EmergencyNumbersComponent",
  mixins : [appSettings],
  data: () => {
    return {
      isLoadingOverview : true,
      hasLoadingError : false,
      btnVisible : false,
      defaultEmergencyNumber : null,
      emergencyNumbers : []
    }
  },
  components: {
    gettingDataOverlay: GettingDataOverlayComponent
  },
  methods : {
    async getDefaultEmergencyNumber(){
      //SET DEFAULT IF PRESENT
      this.defaultEmergencyNumber = {
        number : ((appSettings.data().appSettings.defaultEmergencyNumber)? appSettings.data().appSettings.defaultEmergencyNumber : null),
        display_name : this.$vuetify.lang.t('$vuetify.emergency_numbers.default_number_btn_txt')
      }

      let wsd = await this.$store.getters.getActiveWorkSession;

      if (
          wsd !== null &&
          wsd.project_settings !== null &&
          wsd.project_settings !== undefined &&
          wsd.project_settings.linked_emergency_number !== undefined &&
          wsd.project_settings.linked_emergency_number !== null &&
          typeof wsd.project_settings.linked_emergency_number === 'object'
      ){
        this.defaultEmergencyNumber = wsd.project_settings.linked_emergency_number;
      }

      this.btnVisible = true;
    },
    async getEmergencyNumbersOverviewList(){
      this.isLoadingOverview = true;
      resourcesApi.getEmergencyNumbersOverview().then((response)=>{
        this.isLoadingOverview = false;
        this.emergencyNumbers = response.data
      }).catch((error)=>{
        this.isLoadingOverview = false;
        this.hasLoadingError = true;
        window.console.error(error);
      })
    },
  },
  async mounted(){
    if(!this.$workSessions.loading && !this.hasForceCloseWorkSessionFlag){
      await this.$workSessions.performSessionCheck();
    }
    this.getDefaultEmergencyNumber();
    if(this.$auth.isAuthenticated) {
      this.getEmergencyNumbersOverviewList();
    }
  }
}
</script>

<style scoped>
  .emergency-number-item{
    padding: 0px;
  }
</style>